import { Question, QuestionId } from "@common";
import { grey, green, red } from "@mui/material/colors";
import { DiscussionSlideData } from "../config/discussionSlideData";
import {
  AnswerStat,
  answerStatsTypes,
  BubbleStatsConfig,
  BarStatsConfig,
  StatConfig,
} from "./answerStats.interface";

const questionStates = ["unanswered", "correct", "incorrect"] as const;
export type QuestionState = (typeof questionStates)[number];
export type QuestionVariant = string;

export type QuizSlideDataSequence = Array<SlideData>;

export interface SlideData {
  question?: Question;
  information?: InformationSlideData;
  discussion?: DiscussionSlideData;
  state: QuestionState;
  completed: boolean;
  savedInStorage: boolean;
  answerStat?: AnswerStat;
}

const informationSlideDataTypes = ["segementResults", "lecture"] as const;
type InformationSlideDataType = (typeof informationSlideDataTypes)[number];

export interface InformationSlideData {
  title: string;
  desc: string;
  type: InformationSlideDataType;
  youtubeID?: string;
}

export interface QuestionSlideData {
  type: "question";
  id: string;
  statConfig: StatConfig;
}

export const isInformationSlideData = (val: unknown): val is InformationSlideData => {
  let isAllowedType = false;
  informationSlideDataTypes.forEach((type: InformationSlideDataType) => {
    if ((val as InformationSlideData).type === type) {
      isAllowedType = true;
    }
  });
  return isAllowedType;
};

export const isQuestionSlideData = (val: unknown): val is QuestionSlideData => {
  return (val as QuestionSlideData).type === "question";
};

export const isDiscussionSlideData = (val: unknown): val is DiscussionSlideData => {
  return (val as DiscussionSlideData).allowComments !== undefined;
};

export type NewQuizStructure = Array<
  QuestionSlideData | InformationSlideData | DiscussionSlideData
>;

export const isSlideData = (a: any): a is SlideData => {
  if (!a) return false;
  return Object.keys(a).includes("question") && Object.keys(a).includes("savedInStorage");
};

// export const isQuestionState = (a: any): a is QuestionState => {
//   if (!a) return false;
//   return questionStates.includes(a);
// };

// export const isQuestionId = (a: any): a is QuestionId => {
//   if (!a) return false;
//   return questions.some((question: Question) => Object.values(question.id).includes(a));
// };

// export const isQuestionIds = (a: any): a is Array<QuestionId> => {
//   if (!Array.isArray(a)) return false;
//   return a.every((elem: string) =>
//     questions.some((question: Question) => Object.values(question.id).includes(elem))
//   );
// };

// export const isQuestionVariant = (a: any): a is QuestionVariant => {
//   if (!a) return false;
//   return questions.some((question: Question) => Object.values(question.variant).includes(a));
// };

export const playerBubblesAnswerStatsConfig: BubbleStatsConfig = {
  title: "Hur spelarna har svarat",
  type: answerStatsTypes.bubbles,
  labelAndColorForVal1: {
    label: "forTeachers.notAnswered",
    brightColor: grey[200],
    mainColor: grey[400],
    darkColor: grey[500],
  },
  labelAndColorForVal2: {
    label: "forTeachers.right",
    brightColor: green[200],
    mainColor: green[500],
    darkColor: green[600],
  },
  labelAndColorForVal3: {
    label: "forTeachers.wrong",
    brightColor: red[200],
    mainColor: red[500],
    darkColor: red[600],
  },
};

export const playerBarAnswerStatsConfig: BarStatsConfig = {
  title: "Hur spelarna har svarat",
  type: answerStatsTypes.horizontalBar,
  labelAndColorForBar1: {
    label: "",
    brightColor: grey[200],
    mainColor: grey[400],
    darkColor: grey[500],
  },
  labelAndColorForBar2: {
    label: "",
    brightColor: green[200],
    mainColor: green[500],
    darkColor: green[600],
  },
  labelAndColorForBar3: {
    label: "",
    brightColor: red[200],
    mainColor: red[500],
    darkColor: red[600],
  },
  labelAndColorForBar4: {
    label: "",
    brightColor: red[200],
    mainColor: red[500],
    darkColor: red[600],
  },
  labelAndColorForBar5: {
    label: "",
    brightColor: red[200],
    mainColor: red[500],
    darkColor: red[600],
  },
};
